/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Job_Form_Softskills_Label1Inputs */

const en_job_form_softskills_label1 = /** @type {(inputs: Job_Form_Softskills_Label1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soft Skills`)
};

const de_job_form_softskills_label1 = /** @type {(inputs: Job_Form_Softskills_Label1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soft Skills`)
};

/**
* | output |
* | --- |
* | "Soft Skills" |
*
* @param {Job_Form_Softskills_Label1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const job_form_softskills_label1 = /** @type {((inputs?: Job_Form_Softskills_Label1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Job_Form_Softskills_Label1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_job_form_softskills_label1(inputs)
	return en_job_form_softskills_label1(inputs)
});
export { job_form_softskills_label1 as "job_form_softSkills_label" }